import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'customNumber',
  standalone: false
})
export class CustomNumberPipe implements PipeTransform {
  transform(
    value: any,
    formatType: 'currency' | 'number' = 'number',
    fallback: string = '-'
  ): string {

    if (value === null || value === undefined || value === '') {
      return fallback;
    }

    const num = typeof value === 'string' ? Number.parseFloat(value) : value;
    if (Number.isNaN(num)) {
      return fallback;
    }

    const formattedNumber = Math.abs(num).toLocaleString('en-IN', {
      minimumFractionDigits: 0,
      maximumFractionDigits: 2
    });

    if (formatType === 'currency') {
      if (num === 0) return '₹0';
      return num < 0 ? `-₹${formattedNumber}` : `₹${formattedNumber}`;
    } else {
      if (num === 0) return '0';
      return num < 0 ? `-${formattedNumber}` : formattedNumber;
    }
  }
}
